var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_handlebars_55bd3bc35fc2f307bbfb37e598f2d6f6/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d69d70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_handlebars_55bd3bc35fc2f307bbfb37e598f2d6f6/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 